import React from 'react'
import MaxContent from "../../layout/MaxContent";

import { StrapiImage } from '../Types'
import { fixStrapiUrl } from "../../helpers/strapiUrl";

interface ImageBannerData {
  data: ImageBannerprops
}

interface ImageBannerprops {
  DesktopImage: StrapiImage;
  ImageURL?: string;
  AlternativeText?: string;
}

const ImageBanner= ({ data }: ImageBannerData) => {
  return (
    <MaxContent size="max">
      <div className="">
        <MaxContent size="max">
          <section className="md:h-full flex flex-col justify-around">
          {
            data?.DesktopImage?.url ?
            <img
              src={fixStrapiUrl(data?.DesktopImage?.url)}
              alt={data?.DesktopImage?.alternativeText}
              className="object-cover object-center w-full h-full"
              />
              : data?.ImageURL ?
                <div className="w-full h-full">
                  <img
                    src={data.ImageURL}
                    alt={data.AlternativeText}
                    className="object-cover object-center w-full h-full"
                  />
                </div>
              : null
          }
          </section>
        </MaxContent>
      </div>
    </MaxContent>
  );}

export default ImageBanner;


